import React, { useState } from "react";
import Nav from "./Nav";
import { useMediaQuery } from "react-responsive";

const Header = () => {
  const [isBurgerOn, setIsBurger] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 768 });

  
  const handleBurger = () => {
    const burger = document.getElementById("burger");
    burger.classList.toggle("active");
    isBurgerOn ? setIsBurger(false) : setIsBurger(true);
  };

  return (
    <header style={{ background: isBurgerOn && "black" }}>
      <div className="content-header wrapper">
        <div className="header-nav">
          <img
            src="./assets/logo.svg"
            className="logo"
            alt="logo loopstudios"
          />

          {isDesktop ? (
            <Nav />
          ) : (
            <div id="burger" onClick={() => handleBurger()}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>

        {isBurgerOn ? (
          <Nav />
        ) : (
          <div className="hero-container">
            <h1>Immersive experiences that deliver</h1>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
